export default __webpack_public_path__ + "static/media/icon_clubsAndAssociations.07b42b5a.svg";